import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import { initSentry } from '@pv/common/sentry';

import './index.css';
import App from './App';

const dsn = process.env.REACT_APP_SENTRY_DSN as string;
initSentry({ dsn });

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
